export default {
  terms:
    'Mit deiner Bestellung erklärst du dich mit unseren <TermsLink>Allgemeinen Geschäftsbedingungen</TermsLink> und unserer <PrivacyPolicyLink>Datenschutzerklärung</PrivacyPolicyLink> einverstanden.',
};
